import {
  ApproverPolicy,
  IWorkflowProcessor,
  IWorkflowProcessorExtension,
  IWorkflowValidateTransitionOptions
} from "../PA.Core/PA.Core.IF.Workflow";
import {TPMEventBO} from "./TPMEventBO";
import {ASync} from "../PA.Core/Basic/ASync";
import {WB_TPM_EventSpendRow, WB_UserRow} from "../PA.Core/PAdbSchemaRows";
import {WorkflowProcessor} from "../PA.Core/Workflow/WorkflowProcessor";
import {TPMEventSpend} from "./TPMEventBO.ITPMEventSpend";
import * as _ from "lodash";
import {PaymentMethod_OffInvoice} from "../PA.TPM.Core/TPM.Constants";
import {DateUtils} from "../PA.Core/Basic/Dates";
import {NumberUtils} from "../PA.Core/Basic/Numbers";
import {ErrorMessage_restate} from "../PA.Core/Basic/MessageUtils";
import {TPMEventBOStandardSpendPolicy} from "./TPMEventBO.StdSpendPolicy";
import {ESRecord} from "../PA.Core/lib/ESRecord";
import {ESDataStore} from "../PA.Core/lib/ESDataStore";
import {esWB_TPM_Event_Spend_Product, esWB_TPM_Event_Spend_Product_Group} from "../PA.Core/PAdbSchema";


export class TPMEventBOStandardSpendWorkflowExtension
  implements
    IWorkflowProcessorExtension
{

  tpmEventBO: TPMEventBO
  tpmEventSpend: TPMEventSpend

  constructor(aTPMEventBO: TPMEventBO, tpmEventSpend: TPMEventSpend){
    this.tpmEventBO = aTPMEventBO
    this.tpmEventSpend = tpmEventSpend
  }

  get id(): string{
    return "TPMEventBOStandardSpendWorkflowExtension: " + this.tpmEventSpend.TPMEventSpendRow.cif.EVENT_SPEND_ID
  }

  OnLoad(aWfProcessor: IWorkflowProcessor): Promise<void> {
    const self = this

    return new Promise<void>((resolve, error) => {

      self._setupPolicy(aWfProcessor)  // Don't wait.. it waits for the EventBO to Load
        .then(ignore=> {})
        .catch(ignore => {})

      resolve()
    })
  }

  _setupPolicy(aWfProcessor: IWorkflowProcessor): Promise<void> {
    const self = this

    return new Promise<void>((resolve, error) => {

      // Wait for the Event to Load..
      self.tpmEventBO.OnLoadComplete
        .then((ignore) => {
          // Hide Workflow if not Post Approval and Not OI..
          // Should we drive the status from above, or from the Spend object ..
          let bShowWorkflow = false
          let bNextStateVisisble = false

          let bIsOffInvoice = (self.tpmEventSpend.TPMEventSpendRow.cif.PAYMENT_METHOD == PaymentMethod_OffInvoice)
          let bIsEventPostApproval = self.tpmEventBO.PrimaryWorkflowProcessor.CurrentState.StatusTypeIsPostApproval
          let bIsEventSpendPostApproval = aWfProcessor.CurrentState.StatusTypeIsPostApproval
          let bIsEventSpendClosedOrCancelled = aWfProcessor.CurrentState.StatusTypeClosed || aWfProcessor.CurrentState.StatusTypeClosed

          bShowWorkflow = bIsEventPostApproval
          if(bShowWorkflow){
            bNextStateVisisble = !bIsEventSpendClosedOrCancelled
          }

          if(bShowWorkflow){
            aWfProcessor.setPolicyFields({
              WorkflowVisible: true,
              CurrentStateVisible: true,
              NextStateVisible: bNextStateVisisble,
              NextStateEditable: true
            })
          } else {
            aWfProcessor.setPolicyFields({
              WorkflowVisible: false,
              CurrentStateVisible: false,
              NextStateVisible: false,
              NextStateEditable: false
            })
          }
        })
        .then((ignore)=> {
          resolve()
        })
        .catch((err) => {
          error(err)
        })

    })
  }


  GetApproverPolicy(aWfProcessor: IWorkflowProcessor): Promise<ApproverPolicy> {
    return ASync.resolve(ApproverPolicy.None)
  }

  GetApproverList(aWfProcessor: IWorkflowProcessor): Promise<WB_UserRow[]> {
    let aWp: WorkflowProcessor = <WorkflowProcessor> aWfProcessor
    return ASync.resolve([])
  }


  Validate(aWfProcessor: IWorkflowProcessor, options?: IWorkflowValidateTransitionOptions): Promise<void> {
    const self = this
    const opts = options || {}


    return new Promise<void>((resolve, error) => {
      console.log(self.id, ": Validate Tactic")

      let bo = self.tpmEventBO
      let tpmSpend = self.tpmEventSpend

      //  Validate only State Transitions
      let NextState = aWfProcessor.NextState

      // Check if Next State is overriden.
      if(opts.UsingNextState){
        NextState = opts.UsingNextState
      } else if (opts.UsingNextStateType){
        let optsState = aWfProcessor.getStateType(opts.UsingNextStateType)
        if(_.isArray(optsState)){ optsState = _.first(optsState)}
        if(optsState){
          NextState = optsState
        }
      }
      let NextStateId = NextState.cif.WB_STATUS_ID

      if(aWfProcessor.CurrentStateId == NextStateId){
        resolve()
        return
      }

      let validateFunction: (a: IWorkflowProcessor)=> Promise<void> = undefined

      switch (true) {
        case NextState.StatusTypeInitial:
        case NextState.StatusTypeRejected:
        case NextState.StatusTypeRevisionDenied:
          // No Validation
          break;

        case NextState.StatusTypeApproved:
          // Add Validation Function
          validateFunction = self._validateStateTransition_Approved.bind(self);
          break;

        case NextState.StatusTypePendingApproval:
        case NextState.StatusTypeRevised:
          // No Validation
          break;

        case NextState.StatusTypeCancelled:
          validateFunction = self._validateStateTransition_Cancel.bind(self);
          break;

        case NextState.StatusTypeClosed:
          validateFunction = self._validateStateTransition_Closed.bind(self)
          break;
      }

      if(!_.isFunction(validateFunction)){
        resolve()
        return
      }

      validateFunction(aWfProcessor)
        .then((ignore) => {
          resolve()
        })
        .catch((err) => {
          error(err)
        })
    })
  }


  //<editor-fold desc="Validate Functions">

  private async _validateStateTransition_Approved(aWfProcessor: IWorkflowProcessor): Promise<void> {
    const self = this

      let bo = self.tpmEventBO
      let evt = bo.WB_TPMEvent
      let evtSpend = self.tpmEventSpend
      let evts = evtSpend.TPMEventSpendRow
      let evtsid = evts.cif.EVENT_SPEND_ID
      let currentState = aWfProcessor.CurrentState

      // If record is new, and is OI and starts in the past, raise error..
      if(currentState.StatusTypeIsPreApproval
          && (evts.cif.PAYMENT_METHOD == PaymentMethod_OffInvoice)
          && DateUtils.isLessThan(evts.ShipmentStartDt, DateUtils.today))
      {
        let sStartDate = DateUtils.formatDate(evts.ShipmentStartDt)
        let sMsg = `New Event Spend (${evtsid}) may not be Approved because the Off Invoice Spend starts in the past, ${sStartDate}.`
        // ErrorMessage_restate(aWfProcessor.WorkflowMessageProvider, true, evtsid + '-OIStPast', sMsg)
      }

  }

  private async _validateStateTransition_Cancel(aWfProcessor: IWorkflowProcessor): Promise<void> {
    const self = this

      let bo = self.tpmEventBO
      let evt = bo.WB_TPMEvent
      let evtSpend = self.tpmEventSpend
      let evts = evtSpend.TPMEventSpendRow
      let evtsid = evts.cif.EVENT_SPEND_ID
      let evtsname = evts.cif.EVENT_SPEND_NAME

      let bIsOffInvoice = evts.cif.PAYMENT_METHOD == PaymentMethod_OffInvoice
      let bHasBeenApproved = aWfProcessor.CurrentState.StatusTypeIsPostApproval

      if(bIsOffInvoice && bHasBeenApproved){

        if (evts.ShipmentStartDt.getTime() <= DateUtils.today.getTime()) {
          let sStartDate = DateUtils.formatDate(evts.ShipmentStartDt)
          let sMsg = `Event Spend (${evtsid}) may not be Cancelled because the Off Invoice Spend started in the past, ${sStartDate}.`
          ErrorMessage_restate(aWfProcessor.WorkflowMessageProvider, true, evtsid + '-Wf', sMsg)
        }

        if(evts.cif.OES_SENT_TO_DTTS > 0){
          let sSentDate = DateUtils.formatDateTime(evts.OESSentToDt)
          let sMsg = `Event Spend (${evtsid}) may not be Cancelled because the Off Invoice Spend has been sent to the Order Entry System, ${sSentDate}.`
          ErrorMessage_restate(aWfProcessor.WorkflowMessageProvider, true,evtsid + '-WfSent', sMsg)
        }

      }

      if(bHasBeenApproved){
        // sPaymentIds = await ...
        if(evts.cif.ACTUAL_SPEND > 0){
          let sMsg = `Event Spend (${evtsid}) may not be Cancelled because Payments have been Posted, ` + NumberUtils.formatMoney(evts.cif.ACTUAL_SPEND)
          ErrorMessage_restate(aWfProcessor.WorkflowMessageProvider, true,evtsid + '-WfPmt', sMsg)
        }
      }

  }

  private async _validateStateTransition_Closed(aWfProcessor: IWorkflowProcessor): Promise<void> {
    const self = this

      let bo = self.tpmEventBO
      let evt = bo.WB_TPMEvent
      let evtSpend = self.tpmEventSpend
      let evts = evtSpend.TPMEventSpendRow
      let evtsid = evts.cif.EVENT_SPEND_ID
      let evtsname = evts.cif.EVENT_SPEND_NAME

      let bIsOffInvoice = evts.cif.PAYMENT_METHOD == PaymentMethod_OffInvoice

      if(!bIsOffInvoice){ return }

      if(aWfProcessor.CurrentState.StatusTypeInitial){
        let sMsg = `Event may not be Closed because the Off Invoice Spend (${evtsid}) must be Approved or Cancelled.`
        ErrorMessage_restate(aWfProcessor.WorkflowMessageProvider, true,evtsid + '-WfOIAC', sMsg)
      }

      if(aWfProcessor.CurrentState.StatusTypeApproved) {
        if(evts.ShipmentEndDt.getTime() >= DateUtils.today.getTime()){
          let sEndDate = DateUtils.formatDate(evts.ShipmentEndDt)
          let sMsg = `Event may not be Closed because the Off Invoice Spend (${evtsid}) runs through ${sEndDate}.`
          ErrorMessage_restate(aWfProcessor.WorkflowMessageProvider, true,evtsid + '-WfOIRunning', sMsg)
        }
      }

  }

  //</editor-fold>



  async OnValidatationSucess(aWfProcessor: IWorkflowProcessor): Promise<void> {
    const self = this

    if(aWfProcessor.NextState.StatusTypeClosed){
      self.tpmEventSpend.TPMEventSpendRow.cif.PAID_IN_FULL_IND = '1'
    }

  }

  Save(aWfProcessor: IWorkflowProcessor, bUseBatch?: boolean, options?: any): Promise<void> {
    const self = this

    return new Promise<void>((resolve, error) => {
      console.log(self.id, ": Save")
      let saveFunction: (esName: string, saveRecords: ESRecord[] | ESRecord, options?: any) => Promise<ESDataStore>
      if (bUseBatch) {
        saveFunction = aWfProcessor.dbContext.SaveBatch.bind(aWfProcessor.dbContext)
      } else {
        saveFunction = aWfProcessor.dbContext.Save.bind(aWfProcessor.dbContext)
      }

      // Save the records children
      let record: WB_TPM_EventSpendRow = aWfProcessor._options.Record
      if(!record) {
        resolve()
        return
      }

      // Save these record.. since Approved Spend can be updated after it's been calculated.
      //
      saveFunction(esWB_TPM_Event_Spend_Product_Group, record.WB_TPM_EventSpendPrdGrpRows)
        .then((ignore) => {
          return saveFunction(esWB_TPM_Event_Spend_Product, record.WB_TPM_EventSpendPrdRows)
        })
        .then((ignore) => {
          resolve()
        })
        .catch((err) => {
          error(err)
        })

    })

  }


  OnSaved(aWfProcessor: IWorkflowProcessor): Promise<void> {
    const self = this

    return new Promise<void>((resolve, error) => {
      console.log(self.id, ": OnSaved")

      self._setupPolicy(aWfProcessor)  // Don't wait.. it waits for the EventBO to Load
        .then(ignore=> {
          // Get the Workflow Policy
          let evtSpendPolicy: TPMEventBOStandardSpendPolicy = self.tpmEventSpend.PolicyCollection.Spend
          if(evtSpendPolicy){
            evtSpendPolicy.ResetPolicyState()
          }
        })
        .catch(ignore => {})

      resolve()
    })
  }

  OnReloaded(aWfProcessor: IWorkflowProcessor): Promise<void> {
    const self = this

    return new Promise<void>((resolve, error) => {
      console.log(self.id, ": OnReloaded")
      resolve()
    })
  }


}
